/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Content, { Heading } from '../components/Content';
import SEO from '../components/SEO';

function Article({ data }) {
  const post = data.markdownRemark;

  return (
    <Content as="article">
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />
      <Heading>{post.frontmatter.title}</Heading>
      <p>{post.frontmatter.date}</p>
      <div dangerouslySetInnerHTML={{ __html: post.html }} />
    </Content>
  );
}

const frontmatterShape = PropTypes.shape({
  title: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
});

Article.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string,
      }),
    }).isRequired,
    markdownRemark: PropTypes.shape({
      frontmatter: frontmatterShape,
      html: PropTypes.string.isRequired,
      excerpt: PropTypes.string.isRequired,
    }),
    post: PropTypes.shape({}),
  }).isRequired,
  pageContext: PropTypes.shape({
    next: PropTypes.shape({
      frontmatter: frontmatterShape,
      fields: PropTypes.shape({ slug: PropTypes.string }),
    }),
    previous: PropTypes.shape({
      frontmatter: frontmatterShape,
      fields: PropTypes.shape({ slug: PropTypes.string }),
    }),
  }).isRequired,
};

export default Article;

export const pageQuery = graphql`
  query PageBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        description
      }
    }
  }
`;
